import { MinusCircleIcon } from "@heroicons/react/24/outline";
import moment from "moment";
import { useMemo, useState } from "react";
import { DateValueType } from "react-tailwindcss-datepicker";
import { ListFieldsType } from "src/api/config";
import { myTaskCheckListResultsListName } from "src/api/config/meetings.config";
import { EmptyList } from "src/components/EmptyList";
import Loading from "src/components/Loading";
import SortIcon from "src/components/ui-icons/table/SortIcon";
import { TableHeaderColumnProps } from "src/components/ui/table/Table";
import TGCheckbox from "src/components/ui/TGCheckbox";
import { useAppSelector } from "src/hooks/redux";
import { updateItemRequest } from "src/modules/spItems/api";
import { selectCurrentUser } from "src/modules/users/selector";
import { TaskItem, getStartEndDateByPeriod } from "src/modules/checklistTasks";
import { getCheckListResultWithTaskByFilters } from "src/modules/checklistTasks/api";
import { RootState } from "src/store/rootReducer";
import { FlexCol, FlexRow } from "src/utils/flexLayouts";
import { twMerge } from "tailwind-merge";
import TGButton from "../../../ui/TGButton";
import { addItem } from "src/modules/spItems/actions";
import store from "src/store";

type TableHeadType = "Direction" | "Period" | "Task" | "CompletionCriteria" | "Result";

const tableHeaderContent: Record<TableHeadType, any> = {
  Direction: {
    title: "Направление",
    sort: false,
    style: { width: "10%" },
  },
  Period: {
    title: "Периодичность",
    sort: false,
    style: { width: "10%" },
  },
  Task: {
    title: "Задача",
    sort: false,
    style: { width: "45%" },
  },
  CompletionCriteria: {
    title: "Критерий выполнения",
    sort: false,
    style: { width: "20%" },
  },
  Result: {
    title: "Результат",
    sort: false,
    style: { width: "15%" },
  },
};

function MyTaskCheckListTable({
  items,
  loading,
  cb,
  periodDate,
  onOpenTask,
  onUpdateTask,
}: {
  items: TaskItem[];
  loading: boolean;
  cb: any;
  periodDate: DateValueType;
  onOpenTask: (connectionId: number) => void;
  onUpdateTask: (connectionId: number, changes: Partial<TaskItem>) => void;
}) {
  return (
    <Table
      tableName="Table with favorite documents"
      // count={favoriteItemsCount}
      // numberOfPages={numberOfPages}
      header={tableHeaderContent}
      body={items}
      cb={cb}
      // page={page}
      loading={loading}
      onChangePage={() => console.log("text")}
      periodDate={periodDate}
      onOpenTask={onOpenTask}
      onUpdateTask={onUpdateTask}
    />
  );
}

export default MyTaskCheckListTable;

function Table({
  header,
  body,
  page,
  loading,
  count,
  numberOfPages,
  onChangePage,
  tableName,
  cb,
  periodDate,
  onOpenTask,
  onUpdateTask,
}: {
  header: typeof tableHeaderContent;
  body: TaskItem[];
  loading: boolean;
  count?: number;
  page?: number;
  numberOfPages?: number;
  onChangePage: (page: number) => void;
  tableName: string;
  cb: any;
  periodDate: DateValueType;
  onOpenTask: (connectionId: number) => void;
  onUpdateTask: (connectionId: number, changes: Partial<TaskItem>) => void;
}) {
  const [sortedField, setSortedField] = useState<TableHeadType | null>(null);
  const [sortDirection, setSortDirection] = useState<"asc" | "desc" | "default">("default");

  const handleSort = (field: TableHeadType) => {
    if (sortedField === field) {
      setSortDirection((prevDirection) =>
        prevDirection === "asc" ? "desc" : prevDirection === "desc" ? "default" : "asc",
      );
    } else {
      setSortedField(field);
      setSortDirection("asc");
    }
  };

  const sortedTableBodyContent = useMemo(() => {
    if (!sortedField || sortDirection === "default") {
      return body;
    }

    const sortedData = [...body];

    // sortedData.sort((a, b) => {
    //   if (a[sortedField] && b[sortedField]) {
    //     if (sortedField === "Document" && a[sortedField].Title && b[sortedField].Title) {
    //       return sortDirection === "asc"
    //         ? a[sortedField].Title.toLowerCase().localeCompare(b[sortedField].Title)
    //         : b[sortedField].Title.toLowerCase().localeCompare(a[sortedField].Title);
    //     }

    //     if (sortedField === "NotificationType") {
    //       return sortDirection === "asc"
    //         ? a[sortedField].ID - b[sortedField].ID
    //         : b[sortedField].ID - a[sortedField].ID;
    //     }

    //     if (sortedField === "Author" || sortedField === "Employee") {
    //       return sortDirection === "asc"
    //         ? a[sortedField].Name.localeCompare(b[sortedField].Name)
    //         : b[sortedField].Name.localeCompare(a[sortedField].Name);
    //     }

    //     const valueA = a[sortedField];
    //     const valueB = b[sortedField];

    //     if (isObject(valueA) && isString(valueA) && isString(valueB) && sortedField === "DocumentCode") {
    //       return sortDirection === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    //     }

    //     if (typeof valueA === "string" && typeof valueB === "string") {
    //       return sortDirection === "asc" ? valueA.localeCompare(valueB) : valueB.localeCompare(valueA);
    //     } else if (typeof valueA === "boolean" && typeof valueB === "boolean") {
    //       return sortDirection === "asc" ? Number(valueA) - Number(valueB) : Number(valueB) - Number(valueA);
    //     } else if (moment.isMoment(valueA) && moment.isMoment(valueB)) {
    //       return sortDirection === "asc" ? valueA.unix() - valueB.unix() : valueB.unix() - valueA.unix();
    //     }
    //   }

    //   return 0;
    // });

    return sortedData;
  }, [sortedField, sortDirection, body]) as TaskItem[];

  return (
    <FlexCol className="w-full">
      <TableList
        head={header}
        body={sortedTableBodyContent}
        sort={handleSort}
        sortDirection={sortDirection}
        sortedField={sortedField}
        tableName={tableName}
        cb={cb}
        loading={loading}
        periodDate={periodDate}
        onOpenTask={onOpenTask}
        onUpdateTask={onUpdateTask}
      />
    </FlexCol>
  );
}

function TableList({
  head,
  body,
  sort,
  sortDirection,
  sortedField,
  loading,
  cb,
  periodDate,
  onOpenTask,
  onUpdateTask,
}: {
  head: typeof tableHeaderContent;
  body: TaskItem[];
  sort: (f: TableHeadType) => void;
  sortedField: TableHeadType | null;
  sortDirection: "asc" | "desc" | "default";
  loading: boolean;
  tableName?: string;
  cb: any;
  periodDate: DateValueType;
  onOpenTask: (connectionId: number) => void;
  onUpdateTask: (connectionId: number, changes: Partial<TaskItem>) => void;
}) {
  return (
    <div
      id="table-scroll"
      className={twMerge(
        "w-auto px-6 pb-5 overflow-x-auto bg-white rounded-lg table-custom shadow-custom scrollbar scrollbar-thumb-rounded-lg scrollbar-h-2 scrollbar-thumb-[#D1D5DB]",
        "max-h-[calc(100vh-156px)] max-h-[calc(100dvh-156px)]"
      )}
    >
      <FlexRow className="w-auto min-w-[930px]">
        <div className="flex flex-col min-w-[1235px] grow">
          <FlexRow className="top-0 z-10 gap-x-4 px-6 pt-4 pb-5 -mx-6 -mt-5 text-black bg-white border-b sticky-custom">
            {Object.keys(head).map((fieldKey) => {
              const key = fieldKey as TableHeadType;

              return (
                <TableHeaderColumn
                  key={fieldKey}
                  tableHeaderContent={head[key]}
                  sortDirection={sortedField === key ? sortDirection : "default"}
                  onClick={() => sort(key)}
                />
              );
            })}
          </FlexRow>
          <FlexRow className="mt-4">
            <FlexCol className="grow">
              {loading ? (
                <div className="pt-4">
                  <Loading />
                </div>
              ) : Array.isArray(body) && body.length > 0 ? (
                <div className="divide-y table-wrap">
                  {body.map((item, index) => (
                    <TableListItem
                      item={item}
                      key={index}
                      periodDate={periodDate}
                      onOpenTask={onOpenTask}
                      onUpdateTask={onUpdateTask}
                    />
                  ))}
                </div>
              ) : (
                <EmptyList icon={<MinusCircleIcon width={24} height={24} />} title="Нет задач" />
              )}
            </FlexCol>
          </FlexRow>
        </div>
      </FlexRow>
    </div>
  );
}

// Функция для добавления элемента
export const addOrUpdateItem = async (
  status: "add" | "update",
  body: Partial<Record<keyof ListFieldsType[typeof myTaskCheckListResultsListName], any>>,
) => {
  if (status === "add") {
    return store.dispatch(
      addItem({
        listName: myTaskCheckListResultsListName,
        body,
      }),
    );
  } else {
    return await updateItemRequest({
      listName: myTaskCheckListResultsListName,
      body,
    });
  }
};

export function getStatus(type: "done" | "deviation", state: boolean, isDone: boolean, hasDeviation: boolean): string {
  if (type === "done") {
    return state ? (hasDeviation ? "Оба" : "Выполнено") : hasDeviation ? "Отклонение" : "Не выполнено";
  } else if (type === "deviation") {
    return state ? (isDone ? "Оба" : "Отклонение") : isDone ? "Выполнено" : "Не выполнено";
  }
  return "";
}

export async function updateTaskStatus(
  status: string,
  item: TaskItem,
  currentUser: any,
  periodDate: DateValueType,
  answersToSave?: string,
) {
  if (!periodDate?.startDate) return;

  const completeDate = getStartEndDateByPeriod(item.Period, periodDate.startDate);

  const taskResultItems = await getCheckListResultWithTaskByFilters({
    EmployeeEmail: currentUser.email,
    ConnectionID: item.ConnectionID,
    CompletedDate: completeDate,
  });

  if (taskResultItems.length) {
    await addOrUpdateItem("update", {
      ID: taskResultItems[0].ID,
      TaskStatus: status,
      CompletedDate: moment().toDate(),
      Test: answersToSave,
    });
  } else {
    await addOrUpdateItem("add", {
      Title: item.Task.Title,
      Task: item.ID,
      CheckList: item.CheckListID,
      EmployeeEmail: currentUser.email,
      TaskStatus: status,
      TaskPeriod: item.Period,
      ConnectionID: item.ConnectionID,
      CompletedDate: moment().toDate(),
      PeriodDate: moment(periodDate.endDate).toDate(),
      Test: answersToSave,
    });
  }
}

function TableListItem({
  item,
  periodDate,
  onOpenTask,
  onUpdateTask,
}: {
  item: TaskItem;
  periodDate: DateValueType;
  onOpenTask: (connectionId: number) => void;
  onUpdateTask: (connectionId: number, changes: Partial<TaskItem>) => void;
}) {
  const currentUser = useAppSelector((state: RootState) => selectCurrentUser(state));

  const { isDone, hasDeviation } = item.Result;

  const [isLoading, setLoading] = useState(false);

  async function toggleCompleted(type: "done" | "deviation", state: boolean) {
    const status = getStatus(type, state, isDone, hasDeviation);
    try {
      setLoading(true);
      await updateTaskStatus(status, item, currentUser, periodDate);
    } catch (error) {
      console.log("error toggleCompleted:>> ", error);
    } finally {
      setLoading(false);
    }

    if (type === "done") {
      onUpdateTask(Number(item.ConnectionID), { Result: { ...item.Result, isDone: !item.Result.isDone } });
    } else if (type === "deviation") {
      onUpdateTask(Number(item.ConnectionID), { Result: { ...item.Result, hasDeviation: !item.Result.hasDeviation } });
    }
  }

  function passTest(e: React.MouseEvent<HTMLButtonElement>) {
    // e.stopPropagation();
    console.log("passTest:>> ", item.Test);
  }

  const controlItemCheckboxComponents = useMemo(() => {
    if (item.Test.length > 0) {
      return (
        <>
          <FlexRow>
            <TGButton type="button" onClick={passTest} disabled={item.disabled}>
              Пройти опросник
            </TGButton>
          </FlexRow>
        </>
      );
    }

    return (
      <>
        <FlexRow>
          <TGButton
            iconOnly={true}
            disabled={isLoading || item.disabled}
            iconStyle=""
            icon={
              <TGCheckbox
                disabled={item.disabled}
                labelClass="pointer-events-none text-[14px] font-normal"
                isChecked={isDone}
                checkboxClass={twMerge(item.disabled ? "text-darkblue bg-gray3 " : "bg-white")}
              >
                Выполнено
              </TGCheckbox>
            }
            onClick={(e) => {
              e.stopPropagation();
              toggleCompleted("done", !isDone);
            }}
          />
        </FlexRow>
        <FlexRow>
          <TGButton
            iconOnly={true}
            iconStyle=""
            disabled={isLoading || item.disabled}
            icon={
              <TGCheckbox
                disabled={item.disabled}
                labelClass="pointer-events-none text-[14px] font-normal"
                isChecked={hasDeviation}
                checkboxClass={twMerge(item.disabled ? "text-darkblue bg-gray3" : "bg-white")}
              >
                Выявлено отклонение
              </TGCheckbox>
            }
            onClick={(e) => {
              e.stopPropagation();
              toggleCompleted("deviation", !hasDeviation);
            }}
          />
        </FlexRow>
      </>
    );
  }, [item, isDone, hasDeviation, isLoading]);

  return (
    <FlexRow
      className={twMerge(
        "py-4 cursor-pointer gap-x-4 -mx-2 px-2",
        !hasDeviation && "hover:bg-[#F3F4F6] hover:bg-opacity-50",
      )}
      style={hasDeviation ? { backgroundColor: "rgba(255, 0, 122, 0.1)" } : undefined}
      key={item.ID}
      onClick={() => onOpenTask(Number(item.ConnectionID))}
    >
      <FlexCol className="break-words text-[#637381]" style={{ width: "10%" }}>
        {`${item.Direction}`}
      </FlexCol>
      <FlexCol className="break-words text-darkblue" style={{ width: "10%" }}>
        {item.Period}
      </FlexCol>
      <FlexCol className="break-words text-[#637381] overflow-hidden" style={{ width: "45%" }}>
        <FlexRow className="text-[14px] text-darkblue">{item.Task.Title}</FlexRow>
        <FlexRow className="text-[12px] whitespace-pre-line">{item.Task.Description}</FlexRow>
      </FlexCol>
      <FlexCol className="break-words text-[#637381] whitespace-pre-line" style={{ width: "20%" }}>
        {item.Task.CompletionCriteria}
      </FlexCol>
      <FlexCol className="break-words text-[#637381] gap-y-2.5" style={{ width: "15%" }}>
        {isLoading ? (
          <FlexRow className="justify-start items-center h-full">
            <Loading />
          </FlexRow>
        ) : (
          controlItemCheckboxComponents
        )}
      </FlexCol>
    </FlexRow>
  );
}

export function TableHeaderColumn({ tableHeaderContent, sortDirection, onClick }: TableHeaderColumnProps) {
  return (
    <FlexCol className="select-none" style={tableHeaderContent.style}>
      <FlexRow className="gap-x-2 items-center">
        {tableHeaderContent.icon && <FlexCol>{tableHeaderContent.icon}</FlexCol>}
        <FlexCol className="font-medium whitespace-pre-line w-fit">{tableHeaderContent.title}</FlexCol>
        {tableHeaderContent.sort && (
          <FlexCol className="w-auto cursor-pointer" onClick={onClick}>
            <SortIcon sortDirection={sortDirection} />
          </FlexCol>
        )}
      </FlexRow>
    </FlexCol>
  );
}
